import React from 'react'

import * as service from 'service'
import useFetch from 'hooks/useFetch'
import SubscribeContext from 'contexts/SubscribeContext'

const SubscribeProvider = ({ children }) => {
  const [cart, setCart] = React.useState([])
  const [authenticated, setAuthenticated] = React.useState(false)
  const [authenticatedWithEmail, setAuthenticatedWithEmail] = React.useState(
    false,
  )
  const [requireLogin, setRequireLogin] = React.useState(false)
  const [
    isLoadingLoginWithTokenCached,
    setIsLoadingLoginWithTokenCached,
  ] = React.useState(false)
  const [customer, setCustomer] = React.useState(null)
  const [activeStep, setActiveStep] = React.useState(0)
  const [editData, setEditData] = React.useState(false)

  const { response: responseSeller, isLoading: isLoadingSeller } = useFetch(
    service.recurrence.sellers.info,
  )
  const { response: responsePlans, isLoading: isLoadingPlans } = useFetch(
    service.recurrence.sellers.plans,
  )

  React.useEffect(() => {
    loginWithTokenCached()
    // eslint-disable-next-line
  }, [])

  React.useEffect(() => {
    const persistedState = service.storage.getRecurrenceSubscribeCart()

    setCart(persistedState)
  }, [])

  React.useEffect(() => {
    service.storage.setRecurrenceSubscribeCart(cart)
  }, [cart])

  const loginWithEmail = async data => {
    const seller = responseSeller.data.seller

    await service.recurrence.customers.checkEmail(data)

    const responseSearch = await service.recurrence.customers.search({
      sellerCode: seller.code,
      email: data.email,
    })

    setCustomer(responseSearch.data.customer)
    setAuthenticated(false)
    setAuthenticatedWithEmail(true)
  }

  const loginWithTokenCached = async () => {
    if (!service.storage.hasRecurrenceAuthTokenCustomer()) {
      return
    }

    try {
      setIsLoadingLoginWithTokenCached(true)

      const responseCustomer = await service.recurrence.customers.get({
        clientId: service.storage.getCustomerIdFromToken(),
      })
      const customer = responseCustomer.data.customer

      setCustomer(customer)
      setIsLoadingLoginWithTokenCached(false)
      setAuthenticated(true)
      setAuthenticatedWithEmail(false)
    } catch (error) {
      resetAuthData()
    }
  }

  const login = async data => {
    const responseAuth = await service.recurrence.auth.loginCustomer({
      email: data.email,
      password: data.password,
    })
    const dataAuth = responseAuth.data

    service.storage.setRecurrenceAuthTokenCustomer(dataAuth.authToken)

    const responseCustomer = await service.recurrence.customers.get({
      clientId: dataAuth.customer.id,
    })
    const customer = responseCustomer.data.customer

    setCustomer(customer)
    setAuthenticated(true)
    setAuthenticatedWithEmail(false)
  }

  const resetAuthData = () => {
    setIsLoadingLoginWithTokenCached(false)
    setAuthenticated(false)
    setAuthenticatedWithEmail(false)
    setCustomer(null)
  }

  return (
    <SubscribeContext.Provider
      value={{
        seller: responseSeller ? responseSeller.data.seller : null,
        isLoadingSeller,
        plans: responsePlans ? responsePlans.data.plans : null,
        isLoadingPlans,
        cart,
        setCart,
        isLoadingLoginWithTokenCached,
        setIsLoadingLoginWithTokenCached,
        authenticated,
        setAuthenticated,
        authenticatedWithEmail,
        setAuthenticatedWithEmail,
        requireLogin,
        setRequireLogin,
        loginWithEmail,
        login,
        resetAuthData,
        customer,
        setCustomer,
        activeStep,
        setActiveStep,
        editData,
        setEditData,
      }}
    >
      {children}
    </SubscribeContext.Provider>
  )
}

export default SubscribeProvider
